export default function CommunityHero() {
  return (
    <section className="relative min-h-[85vh] flex items-center justify-center px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6c0661d2c878313b3ea97f737104a00c.jpg"
          alt="地域社会への貢献"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto text-center">
        <div className="inline-flex items-center px-5 py-2 rounded-full bg-white/95 backdrop-blur-sm mb-8">
          <i className="ri-community-line text-[#2D7A3E] text-lg mr-2"></i>
          <span className="text-[#2D7A3E] text-sm font-semibold whitespace-nowrap">地域社会への貢献</span>
        </div>
        
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-8 leading-tight">
          地域と共に成長する<br />
          持続可能な未来
        </h1>
        
        <p className="text-xl md:text-2xl text-white/95 mb-12 max-w-3xl mx-auto leading-relaxed">
          廃校を活用し、新しい産業と雇用を生み出すことで、<br />
          地域経済の活性化と持続可能な地域社会の実現に貢献します。
        </p>


      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}